import type { ReactNode } from 'react';
import { styled } from 'styled-components';

import { NBALogo } from '@sorare/core/src/atoms/icons/NBALogo';
import {
  Horizontal,
  SBHorizontal,
  Vertical,
} from '@sorare/core/src/atoms/layout/flex';
import { BrandL, HeadlineS } from '@sorare/core/src/atoms/typography';
import { useIsTabletAndAbove } from '@sorare/core/src/hooks/device/useIsTabletAndAbove';
import { NBATeams } from '@sorare/core/src/lib/nbaTeams';
import { laptopAndAbove } from '@sorare/core/src/style/mediaQuery';

const formatNbaTeam = (
  team: (typeof NBATeams)[number],
  score: number | undefined
) => ({
  slug: team.slug,
  name: team.name,
  shortName: team.abbreviation,
  pictureUrl: team.svgUrl,
  score,
});

export const getNBATeam = (
  name: (typeof NBATeams)[number]['name'] | undefined | null,
  score?: number
) => {
  if (!name) {
    return undefined;
  }

  const team = NBATeams.findByName(name);
  if (!team) {
    // eslint-disable-next-line no-console
    console.error('mistyped nba team name in brackets');
    return undefined;
  }
  return formatNbaTeam(team, score);
};

const Wrapper = styled(Vertical)`
  position: relative;
  width: 100%;
`;
const Title = styled(SBHorizontal)`
  margin: 0 var(--double-unit);
  & > *:last-child {
    text-align: right;
  }
  @media ${laptopAndAbove} {
    margin: 0 var(--quadruple-unit);
  }
`;

export const PlayoffsLayout = ({ children }: { children: ReactNode }) => {
  const isTabletAndAbove = useIsTabletAndAbove();
  return (
    <Wrapper>
      <Title>
        {!!isTabletAndAbove && <HeadlineS>West</HeadlineS>}

        <BrandL>
          <Horizontal center>
            <NBALogo />
            PLAYOFFS
          </Horizontal>
        </BrandL>

        {!!isTabletAndAbove && <HeadlineS>East</HeadlineS>}
      </Title>

      {children}
    </Wrapper>
  );
};
